import React, { useMemo } from 'react';
import { Table } from 'antd';
import SealApprovalAttachmentsView from '../Admin/SealApprovalAttachmentsView';
import './ExpenseClaimForm.css';

function parsePersonnelLines(formData = {}) {
  let lines = formData.personnel_lines;
  if (typeof lines === 'string') {
    try {
      lines = JSON.parse(lines);
    } catch {
      lines = [];
    }
  }
  return Array.isArray(lines) ? lines : [];
}

function parseAttachments(formData = {}) {
  let attachments = formData.attachments;
  if (typeof attachments === 'string') {
    try {
      attachments = JSON.parse(attachments);
    } catch {
      attachments = [];
    }
  }
  return Array.isArray(attachments) ? attachments : [];
}

const COLUMNS = [
  { title: '序号', dataIndex: 'lineNo', width: 56, fixed: 'left' },
  { title: '姓名', dataIndex: 'employee_name', width: 90 },
  { title: '身份证号', dataIndex: 'id_card', width: 170 },
  { title: '购买/减少', dataIndex: 'change_type_label', width: 90 },
  { title: '参保时间', dataIndex: 'enrollment_month', width: 96 },
  { title: '费用成本归属中心', dataIndex: 'cost_org_name', width: 140, ellipsis: true },
  { title: '社保购买公司', dataIndex: 'social_insurance_company_name', width: 140, ellipsis: true },
  { title: '社保购买类型', dataIndex: 'insurance_purchase_type_label', width: 96 },
  { title: '申请原因', dataIndex: 'apply_reason', width: 180, ellipsis: true }
];

export default function SocialInsuranceChangeReadonlyView({ formData = {} }) {
  const attachments = useMemo(() => parseAttachments(formData), [formData]);
  const rows = useMemo(
    () => parsePersonnelLines(formData).map((line, index) => ({
      key: String(index),
      lineNo: index + 1,
      employee_name: line.employee_name || '—',
      id_card: line.id_card || '—',
      change_type_label: line.change_type_label || line.change_type || '—',
      enrollment_month: line.enrollment_month || '—',
      cost_org_name: line.cost_org_name || line.cost_org_code || '—',
      social_insurance_company_name: line.social_insurance_company_name || '—',
      insurance_purchase_type_label: line.insurance_purchase_type_label || line.insurance_purchase_type || '—',
      apply_reason: line.apply_reason || '—'
    })),
    [formData]
  );

  return (
    <div className="social-insurance-readonly">
      <Table
        size="small"
        pagination={false}
        scroll={{ x: 1100 }}
        columns={COLUMNS}
        dataSource={rows}
      />
      {attachments.length > 0 && (
        <div className="process-form-snapshot-attachments" style={{ marginTop: 12 }}>
          <SealApprovalAttachmentsView attachments={attachments} title="附件" />
        </div>
      )}
    </div>
  );
}
